export default "__VITE_ASSET__Nrep5I6k__"